<template>
    <div>
        <notifications group="custom-style"
                       position="top center"
                   classes= "n-light"
                   :max="3"
                   :ignoreDuplicates = true
                   :closeOnClick = true
                   :width="300"/>
    </div>                
</template>

<script>
import {NotificationEB} from '../store/EventBus/NotificationEB'
import { version as appVersion } from '../../package.json'
export default {
 
    name:"notification",
    data(){
        return {
            notiMsg:null,
            appVersion
        }
    },
     mounted() {
        //  console.log(`${this.$options.name} is mounted`)
         NotificationEB.$on("newNotification", this.handleNewNotification);
        
     },
    methods:{
        handleNewNotification(data){
            this.notiMsg = JSON.parse(data)
            this.notiMsg.motd.forEach(notif => {
                if(notif.AppVersions.indexOf(this.appVersion) !=-1){
                    this.show('custom-style',"",notif)
                }
            });
            
        },
        show (group, type = '', notification) {
            let message = notification.body.join('\n').trim()    
            if ( message != "")
            {
                 const text = `${notification.body.join('\n').trim()}`.trim()
           
                this.$notify({
                    group,
                    title: `${notification.title}`,
                    text,
                    type,
                    duration :60000,
                    data: {
                    randomNumber: Math.random()
                    }
                })

            }
           
        },
        clean (group) {
             this.$notify({ group, clean: true })
        }          
    }
}
</script>

<style >

 .n-light {
  margin: 10px;
  margin-bottom: 0;
  border-radius: 3px;
  font-size: 12px;
  padding: 1px 1px;
 
 
  
}
.vue-notification-template {
    /* background: rgba(81, 58, 232, 0.673) !important; */
}
 .notification-title {
  letter-spacing: 1px;
  text-transform: uppercase;
  font-size: 10px;
  background:  #d4e8fd;
  color: #2589F3;
  padding: 3px;
   
}
.notification-content{
    white-space: pre;
    text-align: left;
    /* margin: 5px; */
    padding: 5px;
    background:  #d4e8fd;
    color: #44699a;
    
    
  
}

</style>